import i18n from "@/i18n";

const DICT = {
  fr: {
    who: "Qui explore\u00A0?",
    subtitle: "Choisis ton explorateur pour retrouver ton Fil de curiosité.",
    manage: "Gérer",
    done: "Terminé",
    add: "Ajouter",
    addExplorer: "Nouvel explorateur",
    edit: "Modifier",
    delete: "Supprimer",
    name: "Prénom",
    namePh: "Ex. Lila, Papa, Théo…",
    avatar: "Emblème",
    color: "Couleur",
    save: "Enregistrer",
    create: "Créer l'explorateur",
    cancel: "Annuler",
    deleteConfirm: "Supprimer cet explorateur ? Son Fil de curiosité sera effacé.",
    switch: "Changer d'explorateur",
    lockedTitle: "Débloque jusqu'à 5 explorateurs",
    lockedDesc: "Le forfait Le Cocoon offre un profil indépendant à chaque membre du foyer, avec son propre Fil de curiosité.",
    lockedCta: "Passer au Cocoon",
    slotsLeft: (n) => `${n} place${n > 1 ? "s" : ""} restante${n > 1 ? "s" : ""}`,
    familyTitle: "Compte Famille",
    familyDesc: "Un profil par membre du foyer, chacun avec son propre Fil de curiosité.",
    nameRequired: "Un prénom est requis.",
  },
  en: {
    who: "Who's exploring?",
    subtitle: "Pick your explorer to find your Thread of curiosity.",
    manage: "Manage",
    done: "Done",
    add: "Add",
    addExplorer: "New explorer",
    edit: "Edit",
    delete: "Delete",
    name: "First name",
    namePh: "e.g. Lila, Dad, Theo…",
    avatar: "Emblem",
    color: "Colour",
    save: "Save",
    create: "Create explorer",
    cancel: "Cancel",
    deleteConfirm: "Delete this explorer? Their Thread of curiosity will be erased.",
    switch: "Switch explorer",
    lockedTitle: "Unlock up to 5 explorers",
    lockedDesc: "The Cocoon plan gives every member of the household an independent profile with its own Thread of curiosity.",
    lockedCta: "Upgrade to Cocoon",
    slotsLeft: (n) => `${n} slot${n > 1 ? "s" : ""} left`,
    familyTitle: "Family Account",
    familyDesc: "One profile per household member, each with its own Thread of curiosity.",
    nameRequired: "A first name is required.",
  },
  es: {
    who: "¿Quién explora?",
    subtitle: "Elige tu explorador para recuperar tu Hilo de curiosidad.",
    manage: "Gestionar",
    done: "Listo",
    add: "Añadir",
    addExplorer: "Nuevo explorador",
    edit: "Editar",
    delete: "Eliminar",
    name: "Nombre",
    namePh: "Ej. Lila, Papá, Theo…",
    avatar: "Emblema",
    color: "Color",
    save: "Guardar",
    create: "Crear explorador",
    cancel: "Cancelar",
    deleteConfirm: "¿Eliminar este explorador? Su Hilo de curiosidad se borrará.",
    switch: "Cambiar de explorador",
    lockedTitle: "Desbloquea hasta 5 exploradores",
    lockedDesc: "El plan El Cocoon ofrece un perfil independiente a cada miembro del hogar, con su propio Hilo de curiosidad.",
    lockedCta: "Pasar a Cocoon",
    slotsLeft: (n) => `${n} plaza${n > 1 ? "s" : ""} restante${n > 1 ? "s" : ""}`,
    familyTitle: "Cuenta Familiar",
    familyDesc: "Un perfil por miembro del hogar, cada uno con su propio Hilo de curiosidad.",
    nameRequired: "Se requiere un nombre.",
  },
  nl: {
    who: "Wie verkent er?",
    subtitle: "Kies je verkenner om je Draad van nieuwsgierigheid terug te vinden.",
    manage: "Beheren",
    done: "Klaar",
    add: "Toevoegen",
    addExplorer: "Nieuwe verkenner",
    edit: "Bewerken",
    delete: "Verwijderen",
    name: "Voornaam",
    namePh: "Bijv. Lila, Papa, Theo…",
    avatar: "Embleem",
    color: "Kleur",
    save: "Opslaan",
    create: "Verkenner aanmaken",
    cancel: "Annuleren",
    deleteConfirm: "Deze verkenner verwijderen? Zijn Draad van nieuwsgierigheid wordt gewist.",
    switch: "Verkenner wisselen",
    lockedTitle: "Ontgrendel tot 5 verkenners",
    lockedDesc: "Het Cocoon-abonnement geeft elk gezinslid een eigen profiel met een eigen Draad van nieuwsgierigheid.",
    lockedCta: "Upgraden naar Cocoon",
    slotsLeft: (n) => `${n} plek${n > 1 ? "ken" : ""} over`,
    familyTitle: "Gezinsaccount",
    familyDesc: "Eén profiel per gezinslid, elk met zijn eigen Draad van nieuwsgierigheid.",
    nameRequired: "Een voornaam is vereist.",
  },
};

export const ft = () => {
  const lang = (i18n.language || "fr").slice(0, 2);
  return DICT[lang] || DICT.fr;
};
